export default __webpack_public_path__ + "static/media/armbands_of_the_whispering_blade.6c420744.jpg";